<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import authService from "../services/auth.service.js";

export default {
  name: "OidcAuth",
  setup() {
    const router = useRouter();

    onMounted(async () => {
      await authService.logout(true);

      const returnUrl = router.currentRoute.value.query.returnUrl || "";
      if (returnUrl != "") {
        router.push(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
      } else {
        router.push("/login");
      }
    });

    return {
      router,
    };
  },
};
</script>
